import React from 'react'
import _ from 'lodash'
import {
  addDays,
  addMonths,
  endOfMonth,
  differenceInMonths,
  differenceInDays,
  format,
  isSameMonth,
} from 'ag-common/facades'
import {CalendarConfig} from '#tools/calendarConfig'
import PropTypes from 'prop-types'

const CalendarHeaderYearly = ({
  date,
  startOfCalendar,
  endOfCalendar,
  calendarType,
  setDate = null,
  setCalendarType = null,
  isDashboardView = false,
  handleClickMonth,
  scrollLeftControl: ScrollLeftControl = () => null,
  scrollRightControl: ScrollRightControl = () => null,
  calendarTypeButtons: CalendarTypeButtons = () => null,
}) => {
  const numberOfMonths = differenceInMonths(endOfCalendar, startOfCalendar) + 1
  const numberOfDays = differenceInDays(endOfCalendar, startOfCalendar) + 1
  const {getBorderColor} = CalendarConfig[calendarType]

  const gridColumnOffset = isDashboardView ? 0 : 1
  const gridTemplateColumns = isDashboardView
    ? `repeat(${numberOfDays}, 1fr)`
    : `284px repeat(${numberOfDays}, 1fr) 40px`

  return (
    <div className="calendar__header calendar__header--monthly" style={{gridTemplateColumns}}>
      <button
        type="button"
        className="calendar__current-year-button"
        disabled
        style={{
          gridColumn: `${differenceInDays(date, startOfCalendar) + 1 + gridColumnOffset} / ${-1 - gridColumnOffset}`,
        }}>
        {format(date, `yyyy`)}
      </button>
      {!isDashboardView && (
        <div className="calendar__controls calendar__controls--left">
          <CalendarTypeButtons />
          <ScrollLeftControl />
        </div>
      )}
      {_.times(numberOfDays, n => (
        <div
          key={`${calendarType}-${addDays(startOfCalendar, n)}`}
          data-date={addDays(startOfCalendar, n)}
          className="calendar__placeholder"
          style={{gridColumn: n + 1 + gridColumnOffset, borderColor: getBorderColor(addDays(startOfCalendar, n))}}
        />
      ))}
      {_.times(numberOfMonths, n => {
        const gridColumn = `${
          differenceInDays(addMonths(startOfCalendar, n), startOfCalendar) + 1 + gridColumnOffset
        } / span ${differenceInDays(endOfMonth(addMonths(startOfCalendar, n)), addMonths(startOfCalendar, n))}`
        const currentMonthClass = isSameMonth(new Date(), addMonths(startOfCalendar, n))
          ? 'calendar__month--current'
          : ''
        return (
          <div
            key={addMonths(startOfCalendar, n)}
            data-date={addMonths(startOfCalendar, n)}
            className={`calendar__month ${currentMonthClass}`}
            style={{gridColumn}}>
            <button
              type="button"
              className="calendar__month__header"
              disabled={!setCalendarType || !setDate}
              onClick={() => handleClickMonth(addMonths(startOfCalendar, n))}>
              {`${format(addMonths(startOfCalendar, n), 'MMM')}`}
            </button>
          </div>
        )
      })}
      {!isDashboardView && (
        <div className="calendar__controls calendar__controls--right">
          <ScrollRightControl />
        </div>
      )}
    </div>
  )
}

CalendarHeaderYearly.propTypes = {
  startOfCalendar: PropTypes.object.isRequired,
  endOfCalendar: PropTypes.object.isRequired,
  setCalendarType: PropTypes.func.isRequired,
  scrollLeftControl: PropTypes.func,
  scrollRightControl: PropTypes.func,
  calendarTypeButtons: PropTypes.func,
  handleClickMonth: PropTypes.func,
}

export default CalendarHeaderYearly
